<template lang="pug">
.csr-wnload-view.container
  .breadcrumb-password-view.pt-3.row
    Breadcrumb(:pathList='pathlist')
  .alert.alert-dismissible.alert-success.mb-4(role='alert')
    .alert__icon
      Icon(name='shield')
    .alert__content
      .text Certificado emitido com sucesso!
    button.btn-close.pt-0(
      type='button',
      data-bs-dismiss='alert',
      aria-label='Fechar'
    )
      Icon(name='xmark')
  .title.text-start
    h2.fw-600 Instalação de Certificado Digital Financeiro e SSL com CSR
  .content-password-view
    .d-flex.flex-row.row
      .col-12.col-lg-6.d-none.d-lg-block.text-center
        img(
          alt='emitir-certificado',
          src='@/assets/images/download-csr-view.svg'
        )
      .col-12.col-lg-6.text-start
        .mb-3
          strong Usuário: {{ form.user }}
        TextArea.mb-2(
          label='Seu Certificado Digital está pronto para download.',
          rows='4',
          v-model='form.csr',
          is-disabled,
          size='185',
          :resizable='false',
          overflowHidden
        )
        .buttons-container.d-flex.justify-content-end.mt-3.gap-3
          button.copy-button.btn.btn-outline-primary(
            type='button',
            @click='handleCopy'
          )
            span Copiar
            Icon.ms-2(name='copy')
          button.download-button.btn.btn-primary(
            type='button',
            @click='handleDownload'
          )
            span Baixar Certificado
            Icon.ms-2(name='download')
    Contact
    ModalOnlyUseOnDesktop
      template(v-slot:message)
        h3 A instalação de um Certificado Digital através do emissor,
          |
          | deve ser feita em um #[strong computador ou notebook.]
    button#modal-only-desktop-issuer-button(
      v-show='false',
      data-bs-target='#modal-only-desktop',
      data-bs-toggle='modal'
    )
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import TextArea from '@/components/Atoms/TextArea.vue'
  import Breadcrumb from '@/components/Molecules/Breadcrumbs.vue'
  import ModalOnlyUseOnDesktop from '@/components/templates/ModalOnlyUseOnDesktop.vue'
  import browserDeviceCheck from '@/utils/browserDeviceCheck'
  import { Tooltip } from 'bootstrap'
  import { useSSLCertificate } from '@/store/Pinia/useSSLCertificate.store'
  import { useMainStore } from '@/store/Pinia/useMain.store'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { mapActions, mapState } from 'pinia'
  import { panelController } from '@/infra/SSLCertificate/panel.controller'
  import { useOeRecaptcha } from '@/composables/useOeRecaptcha'

  export default defineComponent({
    name: 'HomeView',
    components: {
      Contact,
      Icon,
      TextArea,
      Breadcrumb,
      ModalOnlyUseOnDesktop,
    },
    setup() {
      return {
        oeRecaptcha: useOeRecaptcha(),
      }
    },
    data: () => ({
      copyTooltip: null as Tooltip | null,
      isMobile: browserDeviceCheck(),
      form: {
        user: '',
        csr: '',
      },
    }),
    computed: {
      ...mapState(useSSLCertificate, ['sslCertificate']),
      ...mapState(useDynamicForms, ['getPassword']),
      pathlist() {
        return {
          'Guia de instalação SSL': 'ssl-certificate/installation-guide-ssl',
          'Downolad de Certificado Digital com CSR': '',
        }
      },
    },
    methods: {
      ...mapActions(useMainStore, ['clearData']),
      ...mapActions(useSSLCertificate, ['clearDataSSL']),
      async handleCopy() {
        await navigator.clipboard.writeText(this.form.csr)
      },
      handleDownload() {
        const csrBlob = new Blob([this.form.csr], { type: 'text/plain' })

        const csrUrl = URL.createObjectURL(csrBlob)

        const link = document.createElement('a')
        link.href = csrUrl
        link.download = `${this.form.user}.pem`

        link.click()
      },
    },
    async mounted() {
      const recaptchaToken = await this.oeRecaptcha.getToken('panelrecover')
      const response = await panelController.recover({
        solicitacao: this.sslCertificate.user,
        senha: this.getPassword,
        recaptcha_token: recaptchaToken,
      })

      if (response.mensagem.status === 'sucesso') {
        this.clearData()
      }

      this.form.csr = response.mensagem.data

      this.copyTooltip = new Tooltip(
        document.querySelector('.copy-button') as HTMLElement,
        {
          title: 'Certificado copiado!',
          placement: 'top',
          trigger: 'focus',
          delay: { show: 100, hide: 100 },
        },
      )

      this.form.user = this.sslCertificate.user || ''
    },
    async beforeRouteEnter(to, from, next) {
      const sslStore = useSSLCertificate()
      const dynamicFormsStore = useDynamicForms()

      const { user } = sslStore.$state.sslCertificate
      const { senha } = dynamicFormsStore.$state.formData

      if (user === '' && senha === '') {
        return next('/ssl-certificate/login-ssl')
      }

      return next()
    },
  })
</script>

<style lang="stylus" scoped>
  .title
    font-size: 24px
    font-weight: 500
    padding-bottom: 56px

  @media screen and (max-width: 992px)
    .buttons-container
      flex-direction: column
    .copy-button, .download-button
      width: 100%
</style>
